import { z } from "zod/v4";

export const commoditySchema = z.object({
  code: z
    .string()
    .min(1, "bookingV3.commodityErrorRequired")
    .trim(),
  status: z
    .string()
    .optional()
    .refine((val) => val === undefined || val === "active", {
      message: "bookingV3.commodityErrorInactive"
    })
});
